import { Component, Input } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { DatePipe, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MbscDatepickerModule } from '@mobiscroll/angular';

@Component({
  selector: 'app-adjust-missed-punch-alert',
  templateUrl: './adjust-missed-punch-alert.component.html',
  styleUrls: ['./adjust-missed-punch-alert.component.scss'],
  standalone: true,
  imports: [DatePipe, FormsModule, IonicModule, MbscDatepickerModule, NgIf],
})
export class AdjustMissedPunchAlertComponent {
  @Input() min: Date;
  @Input() max: Date;
  @Input() value: Date;
  @Input() split: boolean;
  isDirty: boolean = false;

  constructor(private readonly modalController: ModalController) {}

  closePopover(act: string): void {
    this.modalController.dismiss({
      save: act === 'save',
      value: this.value,
    });
  }
}
